"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _material = require("@mui/material");

var _utilities = require("../../utilities");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["disabled", "fullWidth", "helperText", "horizontal", "label", "margin", "required"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var StyledRadioGroup = (0, _material.styled)(_material.RadioGroup, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== "horizontal";
  }
})(function (_ref) {
  var _ref2;

  var theme = _ref.theme,
      horizontal = _ref.horizontal;
  return _ref2 = {}, (0, _defineProperty2.default)(_ref2, "& .".concat(_utilities.classes.components.MuiFormControlLabel.root), {
    "&:last-child": {
      paddingBottom: horizontal ? theme.spacing(2) : undefined
    }
  }), (0, _defineProperty2.default)(_ref2, "flexDirection", horizontal ? "row" : "column"), _ref2;
});

var RadioGroupField = function RadioGroupField(_ref3) {
  var _ref3$disabled = _ref3.disabled,
      disabled = _ref3$disabled === void 0 ? false : _ref3$disabled,
      _ref3$fullWidth = _ref3.fullWidth,
      fullWidth = _ref3$fullWidth === void 0 ? false : _ref3$fullWidth,
      helperText = _ref3.helperText,
      _ref3$horizontal = _ref3.horizontal,
      horizontal = _ref3$horizontal === void 0 ? false : _ref3$horizontal,
      label = _ref3.label,
      _ref3$margin = _ref3.margin,
      margin = _ref3$margin === void 0 ? "none" : _ref3$margin,
      _ref3$required = _ref3.required,
      required = _ref3$required === void 0 ? false : _ref3$required,
      rest = (0, _objectWithoutProperties2.default)(_ref3, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.FormControl, {
    component: "fieldset",
    disabled: disabled,
    fullWidth: fullWidth,
    margin: margin,
    required: required,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Box, {
      flexGrow: 1,
      mb: 2,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.FormLabel, {
        component: "legend",
        children: label
      }), helperText && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.FormHelperText, {
        children: helperText
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledRadioGroup, _objectSpread({
      horizontal: horizontal
    }, rest))]
  });
};

var _default = RadioGroupField;
exports.default = _default;